module.exports = __webpack_public_path__ + "img/dussartre.0099251f.jpg";